import { useState } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { GeographicParametersSection } from './GeographicParametersSection.jsx';
import { VehicularParametersSection } from './VehicularParametersSection.jsx';
import './Parameters.scss';
import { CommercialParametersSection } from './Commercial/CommercialParametersSection.jsx';
import SurchargesParametersSection from './Surcharges/SurchargesParametersSection.jsx';
import DiscountsParametersSection from './LandingDiscounts/DiscountsParametersSection.jsx';
import CampaignParametersSection from './Campaign/CampaignParametersSection.jsx';

export const Parameters = () => {
  const [openGestion, setOpenGestion] = useState(false);
  const [openRecargos, setOpenRecargos] = useState(false);
  const [openDescuentos, setOpenDescuentos] = useState(false);
  const [openCampaign, setOpenCampaign] = useState(false);
  const [mainTab, setMainTab] = useState('geografico');

  return (
    <>
      <Header />
      <div className="service-with-container container parameters-page">
        <h1 className="title-component parameters-page__title">Parámetros</h1>
        <div className="parameters-page__breadcrumb">
          TUGRUERO / CONFIGURACIÓN / PARÁMETROS
        </div>

        <section className="parameters-accordion">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenGestion((o) => !o)}
            aria-expanded={openGestion}
          >
            <span>Gestión de variables</span>
            <span
              className={`parameters-accordion__chevron ${openGestion ? 'parameters-accordion__chevron--open' : ''
                }`}
            />
          </button>
          {openGestion && (
            <div className="parameters-accordion__body">
              <div className="parameters-page__main-tabs">
                <button
                  type="button"
                  className={
                    mainTab === 'geografico'
                      ? 'parameters-page__main-tab parameters-page__main-tab--active'
                      : 'parameters-page__main-tab'
                  }
                  onClick={() => setMainTab('geografico')}
                >
                  Geográfico
                </button>
                <button
                  type="button"
                  className={
                    mainTab === 'vehicular'
                      ? 'parameters-page__main-tab parameters-page__main-tab--active'
                      : 'parameters-page__main-tab'
                  }
                  onClick={() => setMainTab('vehicular')}
                >
                  Vehicular
                </button>
                <button
                  type="button"
                  className={
                    mainTab === 'comercial'
                      ? 'parameters-page__main-tab parameters-page__main-tab--active'
                      : 'parameters-page__main-tab'
                  }
                  onClick={() => setMainTab('comercial')}
                >
                  Comercial
                </button>
              </div>

              {mainTab === 'geografico' && <GeographicParametersSection />}
              {mainTab === 'vehicular' && <VehicularParametersSection />}
              {mainTab === 'comercial' && <CommercialParametersSection />}
            </div>
          )}
        </section>

        <section className="parameters-accordion parameters-accordion--spaced">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenRecargos((o) => !o)}
            aria-expanded={openRecargos}
          >
            <span>Personalización de recargos</span>
            <span
              className={`parameters-accordion__chevron ${openRecargos ? 'parameters-accordion__chevron--open' : ''
                }`}
            />
          </button>
          {openRecargos && (
            <div className="parameters-accordion__body parameters-accordion__body--plain">
              <SurchargesParametersSection />
            </div>
          )}
        </section>

        <section className="parameters-accordion parameters-accordion--spaced">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenDescuentos((o) => !o)}
            aria-expanded={openDescuentos}
          >
            <span>Códigos de descuentos en landing</span>
            <span
              className={`parameters-accordion__chevron ${openDescuentos ? 'parameters-accordion__chevron--open' : ''}`}
            />
          </button>
          {openDescuentos && (
            <div className="parameters-accordion__body parameters-accordion__body--plain">
              <DiscountsParametersSection />
            </div>
          )}
        </section>

        <section className="parameters-accordion parameters-accordion--spaced">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenCampaign((o) => !o)}
            aria-expanded={openCampaign}
          >
            <span>Personalización de campañas</span>
            <span
              className={`parameters-accordion__chevron ${openCampaign ? 'parameters-accordion__chevron--open' : ''
                }`}
            />
          </button>
          {openCampaign && (
            <div className="parameters-accordion__body parameters-accordion__body--plain">
              <CampaignParametersSection />
            </div>
          )}
        </section>
      </div>
    </>
  );
};
